import { LOGIN_REDIRECT } from './types';

///////////
// Login Redirect //
///////////

export function loginRedriect(url) {
    return {
        type: LOGIN_REDIRECT,
        payload: url && url.length > 0 ? url : ''
    };
}
